// Drawer Overview Summary card: first card, permission-gated Edit record in
// its header, 15/23 paragraph clamped to three lines. More/Less appears only
// when the rendered text actually overflows (measured, re-measured on content
// or width change) and stays available while expanded.
import { T } from "../../../app/tokens.js";
import { InfoTip } from "./InfoTip.jsx";
import { ClampedProse } from "../../../components/ClampedProse.jsx";

export const SUMMARY_TIP = "What's true now. PMO-owned; changes deliberately via Edit record.";

const cardStyle = { background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, minWidth: 0, marginBottom: 12 };
export const cardHead = { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "12px 18px 0" };
export const cardTitle = { margin: 0, fontSize: T.fsXs, fontWeight: T.fwHubTitle, letterSpacing: ".05em", textTransform: "uppercase", color: T.projectsHubNavy, display: "flex", alignItems: "center" };
const primaryBtn = { background: T.projectsHubNavy, color: T.white, border: `1px solid ${T.projectsHubNavy}`, borderRadius: 8, padding: "6px 12px", fontSize: T.fsXs, fontWeight: T.fwBold, cursor: "pointer" };
const linkBtn = { border: 0, background: "transparent", padding: 0, color: T.blue, fontSize: T.fsXs, fontWeight: T.fwBold, cursor: "pointer", fontFamily: "inherit" };

const para = { margin: 0, fontSize: T.fsMd5, lineHeight: "23px", color: T.dark, whiteSpace: "pre-wrap", overflowWrap: "anywhere" };

export function ProjectSummaryCard({ summary, canEdit = false, onEdit, onAddSummary, resetKey }) {
  const text = typeof summary === "string" ? summary.trim() : "";
  return (
    <section data-testid="record-summary-card" aria-labelledby="full-record-title" style={cardStyle}>
      <div style={cardHead}>
        <h2 id="full-record-title" style={cardTitle}>Summary<InfoTip text={SUMMARY_TIP} label="About the record" testId="full-record-info" /></h2>
        {canEdit && <button type="button" data-testid="full-edit-record" onClick={onEdit} style={primaryBtn}>Edit record</button>}
      </div>
      <div style={{ padding: "8px 18px 14px" }}>
        {text ? (
          <ClampedProse text={text} lines={3} resetKey={resetKey} textStyle={para} textId="record-summary-text"
            testId="full-record-summary" probeTestId="record-summary-probe" toggleTestId="record-summary-toggle" />
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span data-testid="full-record-summary-empty" style={{ fontSize: T.fsMd5, lineHeight: "23px", color: T.mid, fontStyle: "italic" }}>No summary yet</span>
            {canEdit && <button type="button" data-testid="record-summary-add" onClick={onAddSummary} style={linkBtn}>Add summary</button>}
          </div>
        )}
      </div>
    </section>
  );
}
